export default __webpack_public_path__ + "static/media/michael-leonardi.fb4fdf2f.jpg";